import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
export var Title = /*#__PURE__*/function () {
  function Title() {
    _classCallCheck(this, Title);
  }

  _createClass(Title, null, [{
    key: "isValidInput",
    value: function isValidInput(value, maxLength) {
      return typeof value === 'string' && value.trim().length > 0 && value.trim().length <= maxLength;
    }
  }, {
    key: "isValidForCreation",
    value: function isValidForCreation(value, maxLength) {
      return Title.isValidInput(value, maxLength);
    }
  }, {
    key: "isValid",
    value: function isValid(value) {
      return value.length >= this.minLength && value.length <= this.maxLength;
    }
  }]);

  return Title;
}();

_defineProperty(Title, "maxLength", 400);

_defineProperty(Title, "minLength", 2);

_defineProperty(Title, "formMaxLength", 200);

_defineProperty(Title, "folderMaxLength", 30);